export default __webpack_public_path__ + "static/media/Fraction_03.6e841f49.png";